import { useQuery } from '@tanstack/react-query';
import { headlessGet } from '../lib/api';
import type { CmsPageData } from '../types/cms';

export function usePage(slug: string | undefined) {
  return useQuery({
    queryKey: ['page', slug],
    queryFn: () => headlessGet<CmsPageData>(`/pages/${encodeURIComponent(slug!)}`),
    enabled: !!slug,
    staleTime: 60_000,
    retry: false,
  });
}
